package com.ragnorak.clanybackoffice.ui.screens

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.clany.backoffice.domain.usecase.DeleteMemberUseCase
import com.clany.backoffice.domain.usecase.GetMembersUseCase
import com.clany.backoffice.model.MemberResponse
import dev.zacsweers.metro.Inject
import kotlinx.coroutines.launch

data class MembersUiState(
    val isLoading: Boolean = false,
    val members: List<MemberResponse> = emptyList(),
    val error: String? = null,
    val page: Int = 1,
    val hasMore: Boolean = true,
    val searchQuery: String = "",
    val deletingMemberId: String? = null
)

class MembersViewModel @Inject constructor(
    private val getMembersUseCase: GetMembersUseCase,
    private val deleteMemberUseCase: DeleteMemberUseCase
) : ViewModel() {

    var uiState by mutableStateOf(MembersUiState())
        private set

    init {
        loadMembers()
    }

    fun loadMembers(page: Int = 1) {
        viewModelScope.launch {
            uiState = uiState.copy(isLoading = true, error = null)
            getMembersUseCase(
                page = page,
                pageSize = 20,
                query = uiState.searchQuery.ifBlank { null }
            )
                .onSuccess { members ->
                    uiState = uiState.copy(
                        isLoading = false,
                        members = if (page == 1) members else uiState.members + members,
                        page = page,
                        hasMore = members.isNotEmpty()
                    )
                }
                .onFailure {
                    uiState = uiState.copy(isLoading = false, error = it.message)
                }
        }
    }

    fun onSearchQueryChanged(query: String) {
        uiState = uiState.copy(searchQuery = query)
        loadMembers(page = 1)
    }

    fun onDeleteMember(memberId: String) {
        uiState = uiState.copy(deletingMemberId = memberId)
    }

    fun dismissDelete() {
        uiState = uiState.copy(deletingMemberId = null)
    }

    fun confirmDelete() {
        val memberId = uiState.deletingMemberId ?: return
        viewModelScope.launch {
            uiState = uiState.copy(isLoading = true)
            deleteMemberUseCase(memberId)
                .onSuccess {
                    val updated = uiState.members.filter { it.id != memberId }
                    uiState = uiState.copy(isLoading = false, members = updated, deletingMemberId = null)
                }
                .onFailure {
                    uiState = uiState.copy(isLoading = false, error = it.message)
                }
        }
    }
}
